<template>
  <v-btn
    class="white sourcery__dialog-close"
    fab
    large
    @click="$emit('click')">
    <v-icon
      color="black"
      size="20">
      $chevronRight
    </v-icon>
  </v-btn>
</template>
<script>
export default {
  name: 'AppDialogCloser',
};
</script>